module.exports = __webpack_public_path__ + "img/deleteLogo.f820f650.svg";